// extracted by mini-css-extract-plugin
export default {"input":"PackageSettings_input__n-0fl","submit":"PackageSettings_submit__iP1U3"};